import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Aetna Marketplace",
  shortName: "Aetna Marketplace",
  slug: "aetna-marketplace-insurance",
  seoTitle: "Aetna Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have an Aetna Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Aetna Marketplace TMS coverage, Aetna Marketplace TMS therapy, Aetna Marketplace depression treatment Florida, Aetna ACA mental health benefits, Aetna Marketplace SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "Aetna offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov), often branded as Coventry Health Care in some regions. These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Aetna Marketplace plans come in different metal tiers — Bronze, Silver, Gold, and Platinum — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl:
    "https://www.aetna.com/individuals-families/shop-for-plans.html",
  officialResourceLabel: "Aetna Marketplace plans",
};

export const AetnaMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AetnaMarketplaceInsurance;
